import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { IArticleBreadcrumb } from './Articlebreadcrumb.definitions';

/** CSS import */
import Styles from './ArticleBreadcrumb.module.scss';

//Components
import Link from "Reuseables/Link";

const ArticleBreadCrumb: React.FC<IArticleBreadcrumb> = ({
  category,
  title,
  url
}: IArticleBreadcrumb) => {
  return <p className={Styles['breadcrumb']}><Link to={url}>{category}</Link> / {title}</p>;
};

export default ArticleBreadCrumb;
